import { sendToDataLayer } from "~/utils/helpers";
import { getFunnelURLWithTracking, useCrossDomainTracking } from "@tempt/ga4-cross-domain-tracking";
import { useLocation } from "@remix-run/react";
import { useCallback } from "react";
import classNames from "classnames";

interface IButton {
  className?: string;
}

const GetStartedButton = ({ className }: IButton) => {
  const location = useLocation();
  const { pathname } = location;
  const { crossDomainParams } = useCrossDomainTracking();
  
  const landingsURL = [
    "/promo",
    "/shereadsromancebooks",
    "/smartbitchestrashybooks",
  ];
  const isLandingPage = landingsURL.includes(pathname);

  const handleClickOnButton = useCallback(() => {
    const isAboutPage = pathname === "/about";
    const baseFunnelURL = isAboutPage
      ? import.meta.env.VITE_ABOUT_FUNNEL_URL
      : pathname === "/promo"
        ? import.meta.env.VITE_PROMO_FUNNEL_URL
        : pathname === "/shereadsromancebooks"
          ? "https://gift.temptromance.com/shereadsromancebooks"
          : pathname === "/smartbitchestrashybooks"
            ? "https://gift.temptromance.com/SBTB"
            : import.meta.env.VITE_FUNNEL_URL;

    // Get funnel URL with cross-domain tracking parameters from context
    const funnelURL = getFunnelURLWithTracking(baseFunnelURL, crossDomainParams);

    sendToDataLayer({
      event: "get_started_clicked",
      property: pathname,
    });
    window.open(funnelURL, "_blank");
  }, [pathname, crossDomainParams]);

  return (
    <button
      onClick={handleClickOnButton}
      className={classNames(
        className && className,
        "max-md:hover:bg-pink transition ease-linear duration-300 hover:bg-[#E5327280] max-md:md:focus-visible:bg-[#E5327280] max-md:md:focus:bg-[#E5327280] max-md:md:active:bg-[#E5327280] leading-6 block text-center bg-pink text-white text-xl p-4 font-bold font-inter rounded-xl shadow-[0px_6px_18.600000381469727px_2px_rgba(10,19,40,0.35)]",
        isLandingPage && "w-[317px] text-[20px] px-8 max-md:w-full",
      )}
    >
      {pathname === "/promo"
        ? "Activate your FREE month"
        : pathname === "/shereadsromancebooks" ||
            pathname === "/smartbitchestrashybooks"
          ? "Get 2 Weeks Free"
          : "Get Started"}
    </button>
  );
};

GetStartedButton.displayName = "Button";

export default GetStartedButton;
